"use client"

import { useState, ReactNode } from 'react'
import AppSidebar from './AppSidebar'
import Header from './Header'
import { HeaderSlotsProvider } from './PageHeader'
import { getStoredUser, getStoredValue } from '../../utils/service'

interface MainLayoutProps {
  children: ReactNode
  activeSection?: string
  setActiveSection?: (section: string) => void
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)

  const storedUser = getStoredUser()
  const user = {
    name: storedUser ? `${storedUser.first_name} ${storedUser.last_name}` : localStorage.getItem('name') || 'User',
    email: storedUser?.email || getStoredValue('email') || '',
    role: storedUser?.role || localStorage.getItem('role') || 'user',
    initials: storedUser && storedUser.first_name && storedUser.last_name
      ? `${storedUser.first_name[0]}${storedUser.last_name[0]}`.toUpperCase()
      : (localStorage.getItem('name') || 'SA').split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }

  return (
    <HeaderSlotsProvider>
    <div className="min-h-screen w-full bg-primary/20 overflow-hidden">
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <AppSidebar user={user} mobileOpen={mobileSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} />

      {/* Below lg (no desktop sidebar) the page fills the whole screen; from lg up it floats
          inside the tinted backdrop, to the right of the sidebar. */}
      <div
        className="fixed inset-0 z-50 flex flex-col bg-white lg:top-3 lg:right-3 lg:bottom-3 lg:left-[var(--panel-left)] lg:rounded-2xl lg:shadow-sm transition-[left] duration-200"
        style={{ '--panel-left': 'calc(var(--sidebar-w, 0px) + 0.75rem)' } as React.CSSProperties}
      >
        <Header user={user} onOpenMobileSidebar={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 min-h-0 overflow-y-auto no-scrollbar lg:rounded-b-2xl px-4 pb-4 sm:px-6 sm:pb-6 pt-2">
          {children}
        </main>
      </div>
    </div>
    </HeaderSlotsProvider>
  )
}

export default MainLayout
